import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FetchHook from "../../../../Api/FetchHooks";
import { userAccount, userAccounts } from "../../../../Redux/userSlice";
import { formatCurrencyV2, getUserDetails } from "../../../../utils/helpers";
import { Backdrop } from "@mui/material";
import { grey } from "@mui/material/colors";
import AlertComponent from "../../../../Components/AlertComponent";
import ActionDialog from "../../../../Components/ActionDialog";
import TableComponent from "../../../../Components/TableComponent";
import Page from "../../../../Components/Page";
import UseServerTable from "../../../../Hooks/UseServerTable";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";

const UserAccounts = ({ showHeader }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loggedInUser = getUserDetails();
  const accData = useSelector((state) => state.usersData.userAccounts);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [user, setUser] = useState(location.state?.user || loggedInUser);

  // const [loading, response, request] = FetchHook();

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const fetchAccounts = useCallback(() => {
  //   if (user?.id) {
  //     request({
  //       url: `account?type="${user?.role}"&entity_id="${user?.id}"`,
  //     });
  //   }
  // }, [user, request]);

  // useEffect(() => {
  //   fetchAccounts();
  // }, [fetchAccounts]);

  // useEffect(() => {
  //   if (response && response.status === 200) {
  //     dispatch(userAccounts(response.data.Loan));
  //   }
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `account?type="${user?.role}"&entity_id="${user?.id}"`,
    onSuccess: (data) => {
      dispatch(userAccounts(data.Loan));
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  useEffect(() => {
    if (location.state === null) {
      setUser(getUserDetails());
    }
  }, [location]);

  const columns = [
    {
      field: "account_number",
      headerName: "Account number",
      width: 200,
    },
    {
      field: "account_name",
      headerName: "Account name",
      width: 300,
    },
    {
      field: "type",
      headerName: "Account type",
      width: 200,
    },
    {
      field: "account_balance",
      headerName: "Account balance",
      width: 200,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (row) => (
        <Button
          variant="outlined"
          color="primary"
          style={{ marginLeft: 16, fontWeight: "bold" }}
          onClick={() => {
            navigate("/dashboard/users/user-profile/account-profile", {
              state: { account: row.row, user: user },
            });
            dispatch(userAccount(row.row));
          }}
        >
          More
        </Button>
      ),
      width: 200,
    },
  ];

  return (
    <Page
      showHeader={showHeader}
      title={"System Accounts"}
      actions={
        <Box>
          {(loggedInUser.role === "admin" ||
            loggedInUser.role === "finance") && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => openDialog("add_account", "Add Account")}
            >
              Add Account
            </Button>
          )}
        </Box>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">User Accounts</Typography>
              )}
            </>
          }
          action={
            <Box>
              {showHeader === false &&
                (loggedInUser.role === "admin" ||
                  loggedInUser.role === "finance") && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => openDialog("add_account", "Add Account")}
                  >
                    Add Account
                  </Button>
                )}
            </Box>
          }
        />
        <CardContent>
          {accData && accData.length <= 0 && gridProps.loading === true ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : accData && accData.length >= 1 ? (
            <TableComponent columns={columns} data={accData} {...gridProps} />
          ) : (
            <ErrorDisplay
              message="No accounts found. Create one!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default UserAccounts;
